import React from "react";
import Hero from "./Hero/Hero";
import Map from "Pages/Home/Map/Map";
import Form from "./Form/Form";

const Contact = () => {
  return (
    <main>
      <Hero />
      <div className="flex flex-col lg:flex-row gap-10">
        <Form />
        <Map />
      </div>
    </main>
  );
};

export default Contact;
